export enum VehicleTypes {
  GET_VEHICLE_TYPE = 'GET_VEHICLE_TYPE',
  CLEAR_VEHICLE_TYPE = 'CLEAR_VEHICLE_TYPE',
}
export interface InitialVehicleType {
  costPerAssistant: string;
  costPerCubicMeter: string;
  costPerKilometer: string;
  costPerOrder: string;
  costPerTon: string;
  createdAt: string;
  driverCost: string;
  packLoadWeight: string;
  payloadCapacity: string;
  updatedAt: string;
  vehicleType?: string;
  vehicleTypeId: string;
}
